"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _swiftInputDateStyle = require("./swift-input-date-style");
var _swiftLabel = _interopRequireDefault(require("./swift-label"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactMoment = _interopRequireDefault(require("react-moment"));
var _time = require("../time");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//import DatePicker from 'react-datepicker'
//import "react-datepicker/dist/react-datepicker.css"

//import DayPicker from 'react-day-picker'
//import 'react-day-picker/lib/style.css'

var formatDate = function formatDate(d) {
  if (d instanceof Date && !isNaN(d.valueOf())) {
    var year = d.getFullYear();
    var month = "".concat(d.getMonth() + 1);
    var day = "".concat(d.getDate());
    return "".concat(month, "/").concat(day, "/").concat(year);
  }
  return '';
};
var SwiftInputDate = function SwiftInputDate(props) {
  var innerRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    overlayFocused = _useState4[0],
    setOverlayFocused = _useState4[1];
  var handleDayChange = function handleDayChange(selectedDay, modifiers, dayPickerInput) {
    var input = dayPickerInput.getInput();
    console.log(selectedDay, modifiers, dayPickerInput, input);

    // this.setState({
    //   selectedDay,
    //   isEmpty: !input.value.trim(),
    //   isDisabled: modifiers.disabled === true,
    // });
  };

  // useEffect(() => {
  //   console.log('overlayFocused', overlayFocused)
  // }, [overlayFocused])
  // useEffect(() => {
  //   console.log('focused', focused)
  // }, [focused])

  var handleDayClick = function handleDayClick(day, modifiers, e) {
    //console.log('day clicked', day, modifiers, e)
    var dayFormatted = formatDate(day);
    //console.log('dayFormatted', dayFormatted)
    innerRef.current.blur();
    props.onChange(dayFormatted);
    //     const value = formatDate(day, format, dayPickerProps.locale);
    // this.setState({ value, typedValue: '', month: day }, () => {
    //   if (onDayChange) {
    //     onDayChange(day, modifiers, this);
    //   }
    //   this.hideAfterDayClick();
    // });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_swiftInputDateStyle.SwiftInputDateStyled, {
    error: props.error && props.helperText ? true : false,
    entered: props.value.length > 0 ? true : false,
    focused: focused,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
      children: props.label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "swift-input-date-moment-wrapper",
      children: [props.value ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "swift-input-date-moment",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMoment.default, {
            calendar: _time.SwiftMomentDateFormats,
            children: props.value
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "swift-input-date-moment-clear",
          onClick: function onClick(e) {
            e.preventDefault();
            e.stopPropagation();
            props.onChange('');
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
            })
          })
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "swift-input-date-moment"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        type: 'text',
        name: props.name,
        ref: innerRef
        // autoFocus={props.autoFocus}
        ,
        disabled: props.disabled,
        value: props.value
        //onChange={(e) => props.onChange(e.currentTarget.value)}
        ,
        autoCorrect: "off"
        // spellCheck={props.autoCorrect === false ? 'off' : 'on'}
        ,
        autoCapitalize: "off",
        autoComplete: "off",
        onFocus: function onFocus() {
          //console.log('input focus!')
          setFocused(true);
          setTimeout(function () {
            setOverlayFocused(false);
          }, 2);
        },
        onBlur: function onBlur() {
          setTimeout(function () {
            if (!overlayFocused) {
              //console.log('setting focused falssseee')
              setFocused(false);
            }
          }, 1);
        }
      }), focused && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        tabIndex: 0 // tabIndex is necessary to catch focus/blur events on Safari
        ,
        onMouseDown: function onMouseDown(e) {
          //console.log('overlay focus!', innerRef.current)
          e.preventDefault();
          //setOverlayFocused(true)

          //innerRef.current.focus()
        },

        onBlur: function onBlur(e) {
          setOverlayFocused(false);
        }
      })]
    }), props.error && props.helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
      error: true,
      children: props.helperText
    }) : null]
  });
};
var _default = SwiftInputDate;
exports.default = _default;